/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

import { withBrandIcon, type BrandIcon } from '../../../icons/with-brand-icon';

const OfficialIcon = lazyForPaint(
	() =>
		import(
			/* webpackChunkName: "@atlassian/logo-third-party/servicenow" */ '@atlassian/logo-third-party/servicenow'
		).then((m) => m.ServiceNowIcon),
	{ moduleId: '@atlassian/logo-third-party/servicenow' },
);

const LazyServiceNowIconComponent = lazyForPaint(
	() => import(/* webpackChunkName: "icon-servicenow" */ './utils').then((m) => m.ServiceNowIcon),
	{ moduleId: '@atlassian/rovo-connectors-config/servicenow/icon' },
);

const LazyServiceNowSearchResultIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-servicenow-search-result" */ './utils').then(
			(m) => m.ServiceNowSearchResultIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/servicenow/search-result-icon' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const ServiceNowIcon: BrandIcon = withBrandIcon(
	(): React.JSX.Element => (
		<Suspense fallback={null}>
			<LazyServiceNowIconComponent />
		</Suspense>
	),
	OfficialIcon,
	'small',
);

export const ServiceNowSearchResultIcon: BrandIcon = withBrandIcon(
	(): React.JSX.Element => (
		<Suspense fallback={null}>
			<LazyServiceNowSearchResultIconComponent />
		</Suspense>
	),
	OfficialIcon,
	'medium',
);
